import { ErrorService } from 'src/app/services/error/error.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { InviteRegistrationService } from './invite-registration.service';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AcceptInvitationRequestModel, TechnicianPersonalDetails } from './invite-registration.models';
import { NetzTranslateService } from '../services/netz-translate.service';
import { DestroyableComponent } from '../common/destroyable.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-invite-registration',
  templateUrl: './invite-registration.component.html',
  styleUrls: ['./invite-registration.component.scss'],
})
export class InviteRegistrationComponent extends DestroyableComponent implements OnInit {
  showPasswordTwo: boolean;
  showPasswordThree: boolean;
  form: FormGroup;
  isLoading = false;
  technicianDetails$: Observable<TechnicianPersonalDetails>;
  pureValue: {};
  untouchedValue: { email: string; password: string; repeatPassword: string; link: string; acceptPolicy: boolean };
  displayTerms: boolean;
  languageOptions: string[] = [];
  errors: string[];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private inviteRegistrationService: InviteRegistrationService,
    private errorService: ErrorService,
    public netzTranslateService: NetzTranslateService
  ) {
    super();

    this.form = new FormGroup(
      {
        email: new FormControl(null, [Validators.required]),
        password: new FormControl(null, [Validators.required]),
        repeatPassword: new FormControl(null, [Validators.required]),
        link: new FormControl(null, [Validators.required]),
        accept_policy: new FormControl(false, [Validators.requiredTrue]),
      },
      [this.validateForm()]
    );
  }

  ngOnInit() {
    this.readToken().then(token => this.loadTechnicianDetails(token));

    this.languageOptions = this.netzTranslateService.getLangs();

    this.preventLeak(this.form.valueChanges).subscribe(_ => (this.errors = null));
  }

  save() {
    this.isLoading = true;
    const requestModel = new AcceptInvitationRequestModel(this.form.value);
    this.preventLeak(this.inviteRegistrationService.acceptInvitation(requestModel)).subscribe(
      () => {
        this.isLoading = false;
        this.router.navigate(['/']);
      },
      (errorResponse: HttpErrorResponse) => {
        this.isLoading = false;
        this.errors = (errorResponse.error.message as string)?.split('|').map(err => err.trim());
      }
    );
  }

  cancel() {
    this.form.reset(this.untouchedValue);
  }

  showTerms(): void {
    this.displayTerms = true;
  }

  selectLanguage(lang: string) {
    this.netzTranslateService.useLanguage(lang);
  }

  validateForm() {
    return (control: FormGroup): ValidationErrors | null => {
      const { value } = control;

      if (value.password === value.repeatPassword) {
        return null;
      }

      return {
        ['invalid']: "Password repeat check doesn't match",
      };
    };
  }

  private loadTechnicianDetails(token: string) {
    this.isLoading = true;

    this.preventLeak(this.inviteRegistrationService.getTechnicianDetailsByLink(token)).subscribe(
      response => {
        this.isLoading = false;
        this.untouchedValue = { email: response.email, password: '', repeatPassword: '', link: token, acceptPolicy: false };
        this.form.reset(this.untouchedValue);
      },
      _err => {
        this.isLoading = false;
        this.router.navigate(['/']);
        this.errorService.throwErrorIfFailure(_err, true);
      }
    );
  }

  private readToken(): Promise<string> {
    return new Promise(resolve => {
      this.route.params.subscribe(params => {
        return resolve(params.token);
      });
    });
  }
}
